module.exports = __webpack_public_path__ + "img/ypyj.d200f37d.svg";